import { Ticket, Message } from './ticket';

export { Ticket, Message };

export class UserInfo {
    constructor() {
        this.LoginId = 0;
        this.UserName = "";
        this.Email = "";
        this.Roles = "";
    }

    public LoginId: number;
    public UserName: string;
    public Email: string;
    public Roles: string;
    public Tickets: Ticket[];
}


// WEBPACK FOOTER //
// ./src/entities/user.ts